import { render } from "./TextList.vue?vue&type=template&id=460306fa&scoped=true"
import script from "./TextList.vue?vue&type=script&lang=js"
export * from "./TextList.vue?vue&type=script&lang=js"

import "./TextList.vue?vue&type=style&index=0&id=460306fa&lang=less&scoped=true"

import exportComponent from "E:\\qq\\前端(1)\\前端\\后台vue\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460306fa"]])

export default __exports__